/**
 * Invariant 1, in the browser: nothing reads `import.meta.env` outside this file.
 *
 * The server has `packages/core/env.ts`; the dashboard has this. The reasons are
 * the same two. A missing variable should fail in one named place instead of
 * flowing into a URL as the string "undefined", and "which settings does the
 * dashboard need" should have a one-file answer. The ESLint fence in
 * eslint.config.js makes it a rule rather than a habit.
 *
 * WHAT MUST NEVER BE HERE
 *
 * Everything in this object ends up in the JavaScript bundle, readable by
 * anyone who opens the page. Vite only exposes variables prefixed VITE_ for
 * that reason. A client id is public by design (the realm's web client is a
 * public client, chapter 15); a client secret, an API key or a database URL is
 * not, and there is no way to hide one in a browser bundle.
 */

export interface Config {
  keycloak: { url: string; realm: string; clientId: string };
  /** The API is same-origin, proxied by Vite in development. */
  apiBase: string;
}

export const config: Config = {
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080',
    realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'stadtpuls',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT ?? 'stadtpuls-web',
  },
  apiBase: '/api/v1',
};
